import type { CoreOfficeDataType } from '~/types/offices';
import RequestVisitComponent from './RequestVisitComponent';
import type { HostDataType } from '~/types/userTypes';

type TProps = {
  office: CoreOfficeDataType;
  hostData: HostDataType;
};

const RequestVisitCard = ({ office, hostData }: TProps) => {
  return (
    <div className="request-visit-card fo-border-sm border-grey-200 rounded-3 p-4">
      <RequestVisitComponent
        office={office}
        hostData={hostData}
      />
    </div>
  );
};

export default RequestVisitCard;
